<template lang="pug">
div
  v-btn(
    v-if="visible",
    @click="dialog = true",
    small,
    outlined,
    color="secondary"
  ) Turn on Online
  v-dialog(v-model="dialog", width="400")
    v-card
      v-toolbar(flat)
        .subtitle-2 Turn on online order
      v-card-text
        v-form(@submit.prevent="turnon")
          .text-center.mb-5
            v-date-picker(v-model="online_start", color="secondary")
          v-btn(type="submit", block, color="secondary") Yes, I Confirm
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment-timezone";
export default {
  data() {
    return {
      dialog: false,
      online_start: moment().format("YYYY-MM-DD"),
    };
  },
  computed: {
    ...mapGetters(["biz"]),
    visible() {
      const items = ["test", "permanently_closed"];
      return !items.includes(this.biz?.standing);
    },
  },
  methods: {
    ...mapActions(["updateBizAccount"]),
    async turnon() {
      const params = {
        bizId: this.biz._id,
        online_start: moment(this.online_start).valueOf(),
      };
      const result = await this.$api.b.action.custom("turnOnOnline", params);
      this.updateBizAccount(result);
      this.dialog = false;
    },
  },
};
</script>